export default __webpack_public_path__ + "static/media/ai-icon.22b7aa2f.svg";